import { Skeleton } from '@mui/material';
import { FC, memo } from 'react';
import { LiSeparator, List, ListItem } from '../../patient-profile-widget.styles';
import { DotSeparatedSkeleton } from '../../shared/skeleton/dot-separated-skeleton';
import { randomBetween } from '../../utils/random-between';
import { NoteInfo, NoteText } from './notes.styles';

export const NotesSkeleton: FC<{ itemCount?: number }> = memo(({ itemCount = 5 }) => {
  const noteString = () => (
    <Skeleton variant="rounded" width={randomBetween(240, 270)} height={14} sx={{ marginTop: '6px' }} />
  );

  const noteItem = (key: number) => {
    return (
      <>
        <ListItem key={key}>
          <NoteInfo>
            <DotSeparatedSkeleton />
          </NoteInfo>
          <NoteText>
            <Skeleton variant="rounded" width={randomBetween(180, 240)} height={14} />
            {Math.random() < 0.1 && noteString()}
            {Math.random() < 0.2 && noteString()}
            {Math.random() < 0.3 && noteString()}
            {Math.random() < 0.4 && noteString()}
            {Math.random() < 0.5 && noteString()}
          </NoteText>
        </ListItem>
        {key !== itemCount - 1 && <LiSeparator key={1000 + key} />}
      </>
    );
  };

  return <List>{Array.from({ length: itemCount }, (_, index) => noteItem(index))}</List>;
});
